import { Button } from '@bambi/component-library/src/components/Button';

import { DataGrid } from 'src/common/DataGrid';

import { bulkPriceTripsModalColumns } from './columns';
import { useSelectedTripsStepViewModel } from './useSelectedTripsStepsViewModel';

interface SelectedTripsStepProps {
  next: () => void;
  setOpen: (open: boolean) => void;
  setError: (error: string | null) => void;
}

export const SelectedTripsStep = ({
  next,
  setOpen,
  setError,
}: SelectedTripsStepProps) => {
  const {
    handleSubmit,
    loading,
    tableClass,
    tripsOutsideDateRange,
    tripsToPrice,
  } = useSelectedTripsStepViewModel(next, setError);

  return (
    <div>
      {tripsToPrice.length > 0 && (
        <div className="my-4">
          <p className="pb-4 text-sm">
            The following trips will have a new price generated. You can confirm
            the price changes in the next step.
          </p>
          <DataGrid
            tableId="trips-to-price"
            containerClassName={tableClass}
            data={tripsToPrice}
            columns={bulkPriceTripsModalColumns}
            includePagination={false}
            dataTestId="trips-to-price-table"
          />
        </div>
      )}

      {tripsOutsideDateRange.length > 0 && (
        <div className="mb-4">
          <h2 className="text-lg">Trips Outside 60 Day Range</h2>
          <p className="pb-4 text-sm">
            Bulk trip pricing is only available for trips within 60 days of the
            current date (30 days in the past and 30 days in the future).
          </p>

          <DataGrid
            tableId="trips-outside-date-range"
            containerClassName={tableClass}
            data={tripsOutsideDateRange}
            columns={bulkPriceTripsModalColumns}
            includePagination={false}
            dataTestId="trips-outside-date-range-table"
          />
        </div>
      )}

      <div className="flex flex-row justify-end gap-4 pt-6">
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button
          loading={loading}
          variant="primary"
          onClick={() => handleSubmit()}
          disabled={!tripsToPrice.length}
        >
          {loading ? 'Pricing Trips...' : 'Price Trips'}
        </Button>
      </div>
    </div>
  );
};
